module.exports = __webpack_public_path__ + "media/images/landing/people-retina-35894442d0b277c0a2b25d75e0a1cf7d.png";